import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getIsEnabledAddToCartSelector } from 'bento-ordering/menus/selectors';
import PrimaryCta from 'components/Buttons/PrimaryCta';
import { getAddToCartLabel } from 'helpers/forms/addToCartCta';
import {
  productPreviewHelperSelectorMenuItem,
  productPreviewHelperSelectorCartItem
} from 'bento-ordering/menus/reducers/productPreview';
import { ADD_TO_CART } from 'constants/menu/ctaName';
import useIsPreviewMenuOn from 'hooks/useIsPreviewMenuOn';

const MenuItemSubmitContainer = ({
  canAddToCart,
  isAddingToCart,
  isUpdatingPreview,
  cartErrors,
  requiredFieldsAreSelected,
  defaultCtaName,
  previewedQuantityExceedsInventory,
  isSoldOut,
  handleClick,
  hasExceededSpendingLimit
}) => {
  const isPreviewMenuOn = useIsPreviewMenuOn();

  // can add to cart
  // indicates that required
  // fields have been selected
  // dollar max hasn't been breached,
  // and that the menu item is
  // is available (the active menu
  // given fulfillment options contains this item)
  // should refactor here to combine these in a selector or
  // or pull out component booleans
  // for can add to cart

  const isDisabled =
    !canAddToCart ||
    isAddingToCart ||
    previewedQuantityExceedsInventory ||
    isSoldOut ||
    isUpdatingPreview ||
    !!cartErrors.length ||
    isPreviewMenuOn ||
    hasExceededSpendingLimit;

  return (
    <PrimaryCta
      disabled={isDisabled}
      handleClick={handleClick}
      type="submit"
      fullWidth
      label={getAddToCartLabel(
        requiredFieldsAreSelected,
        isAddingToCart,
        defaultCtaName,
        isSoldOut,
        isPreviewMenuOn,
        hasExceededSpendingLimit
      )}
      dataTestId="menu-item-detail-add-to-cart"
      allowPreview
    />
  );
};

MenuItemSubmitContainer.propTypes = {
  canAddToCart: PropTypes.bool,
  isAddingToCart: PropTypes.bool,
  isUpdatingPreview: PropTypes.bool,
  cartErrors: PropTypes.arrayOf(PropTypes.string),
  requiredFieldsAreSelected: PropTypes.bool,
  defaultCtaName: PropTypes.string,
  previewedQuantityExceedsInventory: PropTypes.bool,
  isSoldOut: PropTypes.bool,
  handleClick: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  modifierGroups: PropTypes.array,
  hasExceededSpendingLimit: PropTypes.bool
};

MenuItemSubmitContainer.defaultProps = {
  defaultCtaName: ADD_TO_CART,
  handleClick: () => {},
  modifierGroups: [],
  hasExceededSpendingLimit: false
};

const mapStateToProps = (state, ownProps) => {
  const previewSelector =
    ownProps.formType === 'MENU_ITEM'
      ? productPreviewHelperSelectorMenuItem
      : productPreviewHelperSelectorCartItem;

  return {
    isAddingToCart: state.cart.isFetching,
    cartErrors: state.cart.error,
    ...previewSelector(state),
    ...getIsEnabledAddToCartSelector(state, ownProps.modifierGroups)
  };
};

export default connect(mapStateToProps)(MenuItemSubmitContainer);
